module.exports = __webpack_public_path__ + "e264a6264f02dd9b1afba338062b2d75.svg";